import Rebase from 're-base';
import firebase from 'firebase/app';
import 'firebase/database';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyC8UHQ_vZyGXEAr1_t4Lf-ZrZknTcn1lmw",
    authDomain: "flow-timer-a33a9.firebaseapp.com",
    databaseURL: "https://flow-timer-a33a9.firebaseio.com"
});

const base = Rebase.createClass(firebaseApp.database());

export { firebaseApp }

export default base;


// WEBPACK FOOTER //
// ./src/base.js